<template>
  <div>
    <div class="layout-topbar clearfix">
      <div
        style="display: flex; justify-content: space-between; align-items: center;"
      >
        <div>
          <button class="layout-menu-button p-link" @click="onMenuButtonClick">
            <i class="pi pi-bars"></i>
          </button>
          <div style="display: flex; align-items:center; margin-bottom: 5px;">
            <img
              style="width: 60px; margin: 10px 10px 0px 20px"
              id="layout-topbar-logo1"
              alt="MBP Group Synergy System"
              src="../public/mbp_logo.png"
            />
            <span class="title3">Group Synergy System</span>
          </div>
        </div>

        <div>
          <button
            id="topbar-menu-button"
            class="p-link"
            @click="onTopbarMenuButtonClick"
          >
            <i class="pi pi-ellipsis-v"></i>
          </button>

          <ul :class="topbarItemsClass">
            <li
              v-if="profileMode === 'popup' || horizontal"
              :class="[
                'user-profile',
                { 'active-topmenuitem': activeTopbarItem === 'profile' }
              ]"
              @click="
                $emit('topbar-item-click', {
                  originalEvent: $event,
                  item: 'profile'
                })
              "
            >
              <button class="p-link">
                <img
                  alt="MBP Group Synergy System"
                  src="../public/mbp_logo.png"
                />
                <span class="topbar-item-name">Arlene Welch</span>
              </button>

              <transition name="layout-submenu-container">
                <ul class="fadeInDown" v-show="activeTopbarItem === 'profile'">
                  <li role="menuitem">
                    <button
                      class="p-link"
                      @click="(logoFormDialog = true), reloadLogoForm++"
                    >
                      <i class="pi pi-user"></i>
                      <span>Profile</span>
                    </button>
                  </li>
                </ul>
              </transition>
            </li>

            <li
              :class="[
                { 'active-topmenuitem': activeTopbarItem === 'settings' }
              ]"
              @click="
                $emit('topbar-item-click', {
                  originalEvent: $event,
                  item: 'settings'
                })
              "
            >
              <button class="p-link">
                <i class="topbar-icon pi pi-bell"></i>
                <span class="topbar-item-name">Alerts</span>
                <span v-if="newCurrentUserAlerts" class="topbar-badge">{{
                  newCurrentUserAlerts
                }}</span>
              </button>

              <transition name="layout-submenu-container">
                <ul class="fadeInDown" v-show="activeTopbarItem === 'settings'">
                  <li>
                    <ProgressSpinner
                      v-if="loading"
                      style="width:100%; height:25px;"
                      strokeWidth="5"
                      fill="#EEEEEE"
                      animationDuration=".5s"
                    />
                    <ul
                      class="fadeInDown"
                      v-show="activeTopbarItem === 'settings'"
                      style="width: 300px; height: 500px; overflow-y: scroll; padding-left: 0px; list-style: 0px;"
                      v-else
                    >
                      <li
                        v-for="(item, index) in activeCurrentUserAlerts"
                        :key="index"
                        role="menuitem"
                      >
                        <button
                          @click="processAlert(item)"
                          class="topbar-message p-link"
                        >
                          <span style="color:red;" v-if="!item.alertSeen"
                            >{{ item.source }}: {{ item.alertDesc }}</span
                          >
                          <span v-else
                            >{{ item.source }}: {{ item.alertDesc }}</span
                          >
                        </button>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Button @click="$emit('viewAllAlerts')">
                      <span style="color: white;">View all alerts</span>
                    </Button>
                  </li>
                </ul>
              </transition>
            </li>

            <li
              :class="[
                { 'active-topmenuitem': activeTopbarItem === 'messages' }
              ]"
              @click="
                $emit('topbar-item-click', {
                  originalEvent: $event,
                  item: 'messages'
                })
              "
            >
              <button class="p-link">
                <i class="topbar-icon pi pi-heart"></i>
                <span class="topbar-item-name">Messages</span>
              </button>

              <transition name="layout-submenu-container">
                <ul class="fadeInDown" v-show="activeTopbarItem === 'messages'">
                  <li>
                    <ul
                      class="fadeInDown"
                      v-show="activeTopbarItem === 'messages'"
                      style="width: 300px; height: 500px; overflow-y: scroll; padding-left: 0px; list-style: 0px;"
                    >
                      <li role="menuitem">
                        <FavouritesTable
                          :favourites="favFilters"
                          :reloadComponent="reloadFavouritiesTable"
                          @selected="loadFilter"
                        />
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Button @click="$emit('editAllFavourities', favFilters)">
                      <span style="color: white;">EDIT FAVOURITES</span>
                    </Button>
                  </li>
                </ul>
              </transition>
            </li>

            <li
              :class="[
                { 'active-topmenuitem': activeTopbarItem === 'notifications' }
              ]"
              @click="
                $emit('topbar-item-click', {
                  originalEvent: $event,
                  item: 'notifications'
                })
              "
            >
              <button class="p-link">
                <i class="topbar-icon pi pi-cog"></i>
                <span class="topbar-item-name">Settings</span>
              </button>

              <transition name="layout-submenu-container">
                <ul
                  class="fadeInDown"
                  v-show="activeTopbarItem === 'notifications'"
                >
                  <li role="menuitem">
                    <button class="p-link" @click="toggleTheme()">
                      <i class="pi pi-image"></i>
                      <span>Change Theme</span>
                    </button>
                  </li>
                  <li role="menuitem">
                    <button class="p-link" @click="notificationSettings()">
                      <i class="pi pi-bell"></i>
                      <span>Notification Settings</span>
                    </button>
                  </li>
                  <li role="menuitem">
                    <button class="p-link" @click="passwordDialog = true">
                      <i class="pi pi-fw pi-ellipsis-h"></i>
                      <span>Change Password</span>
                    </button>
                  </li>
                  <li role="menuitem">
                    <button class="p-link" @click="logout">
                      <i class="pi pi-fw pi-sign-out"></i>
                      <span>Logout</span>
                    </button>
                  </li>
                </ul>
              </transition>
            </li>

            <li
              :class="[
                'user-profile',
                { 'active-topmenuitem': activeTopbarItem === 'profile' }
              ]"
              @click="
                $emit('topbar-item-click', {
                  originalEvent: $event,
                  item: 'profile'
                })
              "
            >
              <button class="p-link" @click="$emit('screenshot')">
                <i class="topbar-icon pi pi-image"></i>
                <span class="topbar-item-name">Support Case</span>
              </button>
            </li>
            <li
              v-if="!isVideosPage"
              :class="[
                'user-profile',
                { 'active-topmenuitem': activeTopbarItem === 'profile' }
              ]"
              @click="
                $emit('topbar-item-click', {
                  originalEvent: $event,
                  item: 'profile'
                })
              "
            >
              <button class="p-link" @click="watchVideos()">
                <i class="topbar-icon pi pi-video"></i>
                <span class="topbar-item-name">Watch Videos</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <ChangePassword
      :passwordDialog="passwordDialog"
      @close="passwordDialog = false"
      @save="save"
    />

    <LogoForm
      :attachmentForm="logoFormDialog"
      :reloadForm="reloadLogoForm"
      @close="logoFormDialog = false"
    />

    <NotificationForm
      :notificationForm="notificationForm"
      :reloadForm="reloadNotificationForm"
      :refreshForm="refreshNotificationForm"
      @close="notificationForm = false"
      @saved="notificationForm = false"
    />
  </div>
</template>

<script>
import UserService from "@/service/UserService.js";
import AlertService from "@/service/AlertService.js";

import ChangePassword from "@/mbp/auth/ChangePassword";
import LogoForm from "@/mbp/universalComponents/attachment/LogoForm";
import FavouritesTable from "@/mbp/universalComponents/filter/FavouritiesTable";
import NotificationForm from "@/mbp/universalComponents/user/NotificationForm";

export default {
  created() {
    this.alertsInterval = setInterval(() => {
      this.getNewCurrentUserAlerts();
      this.getActiveCurrentUserAlerts();
    }, 300000);
    this.getNewCurrentUserAlerts();
    this.getActiveCurrentUserAlerts();
  },
  unmounted() {
    clearInterval(this.alertsInterval);
  },
  components: {
    ChangePassword,
    LogoForm,
    FavouritesTable,
    NotificationForm
  },
  props: {
    topbarMenuActive: Boolean,
    activeTopbarItem: String,
    profileMode: String,
    horizontal: Boolean
  },
  data: () => ({
    userService: new UserService(),
    alertService: new AlertService(),

    passwordDialog: false,
    logoFormDialog: false,
    reloadLogoForm: 0,
    reloadFavouritiesTable: 0,
    newCurrentUserAlerts: null,
    activeCurrentUserAlerts: [],
    alertsInterval: null,
    loading: false,
    notificationForm: false,
    reloadNotificationForm: 0,
    refreshNotificationForm: 0
  }),
  computed: {
    profile() {
      return this.$store.getters["auth/getMyProfile"];
    },
    isVideosPage() {
      return this.$route.name === "videos";
    },
    topbarItemsClass() {
      return [
        "topbar-menu fadeInDown",
        {
          "topbar-menu-visible": this.topbarMenuActive
        }
      ];
    },
    favFilters() {
      return this.$store.getters["commons/favoriteFilters"];
    }
  },
  watch: {
    profile(val) {
      if (
        val &&
        val.id &&
        !(this.activeCurrentUserAlerts && this.activeCurrentUserAlerts.length)
      ) {
        this.getActiveCurrentUserAlerts();
      }
    },
    favFilters() {
      this.reloadFavouritiesTable++;
    }
  },
  methods: {
    processAlert(alert) {
      if (alert && alert.id) {
        if (!alert.alertSeen) {
          this.alertService
            .updateAlert(alert.id, { alertSeen: true })
            .then(data => {
              this.getNewCurrentUserAlerts();
              this.getActiveCurrentUserAlerts();
            })
            .catch(error => {
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Error while updating alert.",
                life: 5000
              });
            });
        } else {
          this.alertService
            .updateAlert(alert.id, { alertSeen: false })
            .then(data => {
              this.getNewCurrentUserAlerts();
              this.getActiveCurrentUserAlerts();
            })
            .catch(error => {
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Error while updating alert.",
                life: 5000
              });
            });
        }

        this.$emit("processAlert", alert);
      }
    },
    getNewCurrentUserAlerts() {
      this.alertService
        .getNewCurrentUserAlerts()
        .then(data => {
          this.newCurrentUserAlerts = data;
        })
        .catch(error => {
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "getNewCurrentUserAlerts"'
          });
        });
    },
    getActiveCurrentUserAlerts() {
      this.loading = true;
      this.alertService
        .getActiveCurrentUserAlerts()
        .then(data => {
          // sorting alerts
          var alerts = data.map(alert => {
            let a = alert.dateCreated
                .substr(0, 10)
                .split("/")
                .map(a => parseInt(a)),
              b = alert.dateCreated
                .substr(11)
                .split(":")
                .map(a => parseInt(a));

            return {
              ...alert,
              timeCreated: new Date(a[2], a[1], a[0], b[0], b[1]).getTime()
            };
          });
          alerts = alerts.sort((alert1, alert2) => {
            //
            return alert2.timeCreated - alert1.timeCreated;
          });
          //
          //
          this.loading = false;
          this.activeCurrentUserAlerts = alerts;
        })
        .catch(error => {
          this.loading = false;
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "getNewCurrentUserAlerts"'
          });
        });
    },
    loadFilter(filter) {
      if (filter.favouriteName) {
        let parts = filter.favouriteName.split(":");
        if (parts[0]) {
          try {
            this.$store.dispatch(
              `${parts[0].toLowerCase()}/setMainListSavedFilter`,
              filter
            );

            if (this.$route.name === parts[0].toLowerCase()) {
              this.$store.dispatch(`${parts[0].toLowerCase()}/addSoftReload`);
            } else {
              let a = this.$store.getters[
                `${parts[0].toLowerCase()}/getFirstTimeLoad`
              ];

              if (a) {
                this.$store.dispatch(
                  `${parts[0].toLowerCase()}/setFirstTimeLoad`,
                  false
                );

                this.$store.dispatch(`${parts[0].toLowerCase()}/setSort`, {
                  sortField: "",
                  sortFieldId: 0,
                  sortOrder: 0
                });
                this.$store.dispatch(`${parts[0].toLowerCase()}/setPage`, {
                  page: 1,
                  rows: 25
                });
                this.$store.dispatch(
                  `${parts[0].toLowerCase()}/setMainListQuickFilters`,
                  []
                );
                this.$store.dispatch(
                  `${parts[0].toLowerCase()}/setQuickFiltersDatesFrom`,
                  []
                );
                this.$store.dispatch(
                  `${parts[0].toLowerCase()}/setQuickFiltersDatesTo`,
                  []
                );
              }

              this.$router.push({ name: parts[0].toLowerCase() });
            }
          } catch (e) {}
        }
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "Type not found.",
          detail: "FavoriteName is not present.",
          life: 5000
        });
      }
    },
    logout() {
      localStorage.removeItem("profile");
      localStorage.removeItem("user-token");
      localStorage.removeItem("user-refresh-token");
      setTimeout(() => {
        this.$store.dispatch("auth/setMyProfile", {});
        this.$store.dispatch("auth/setMyToken", "");
        this.$store.dispatch("auth/setMyRefreshToken", "");
        this.$router.push("/login?logout=true");
      }, 10);
    },
    save(password) {
      this.passwordDialog = false;

      this.userService
        .updatePassword({
          idToken: this.$store.getters["auth/getMyToken"],
          password,
          returnSecureToken: true
        })
        .then(data => {
          this.$toast.add({
            severity: "success",
            summary: "Success",
            detail: "Password updated successfully.",
            life: 5000
          });
        })
        .catch(e => {
          if (e.response.status !== 200) {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating password.",
              life: 5000
            });
          }

          if (e.response.status === 400) {
            this.$router.push("/login");
          }
        });
    },
    toggleTheme() {
      this.$store.dispatch("setThemeBar", !this.$store.getters.getThemeBar);
    },
    onMenuButtonClick(event) {
      setTimeout(() => {
        this.$store.dispatch("resetSplitButtonLocation");
      }, 270);
      this.$emit("menubutton-click", event);
    },
    onTopbarMenuButtonClick(event) {
      this.$emit("topbar-menubutton-click", event);
    },
    watchVideos() {
      this.$router.push({ name: "videos" });
    },
    notificationSettings() {
      this.notificationForm = true;
      this.reloadNotificationForm++;
    }
  }
};
</script>
<style scoped lang="scss">
@media screen and (max-width: 441px) {
  .title1 {
    display: none !important;
  }
}

@media screen and (min-width: 895px) {
  .title1 {
    display: none !important;
  }
}

.title {
  align-items: center;
  background-color: transparent;
  border: rgba(0, 0, 0, 0);
  margin: 0 auto;
  padding-top: 5px;
}

.title1 {
  display: flex;
}

.title2 {
  font-size: 18px;
  font-weight: 500;
  color: white;
  padding-left: 5px;
}

.title3 {
  display: inline-block;
  color: white;
  font-size: 20px;
  padding-top: 5px;

  @media (max-width: 430px) {
    display: none;
  }
}
</style>
